import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { config, Font } from '../../../constants'
import { Callback } from '../../../modules/callback'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'
import { escapeHtml, unescapeHtml } from '../../../modules/utils'
import { Routing } from '../../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'partnerSignup', {
  organizationDescriptionTitle: 'Description de votre organisation',
  organizationName: "Nom de l'organisation*",
  organizationNamePlaceholder: "Nom de l'organisation",
  organizationAddressTitle: "Adresse complète de l'organisation",
  organizationAddress1: 'Adresse 1*',
  organizationAddressPlaceholder: 'Numéro et rue',
  organizationAddress2: 'Adresse 2',
  organizationAddress2Placeholder: 'Appartement, suite, etc.',
  organizationCity: 'Ville*',
  organizationCityPlaceholder: 'Ville',
  organizationProvince: 'Province*',
  organizationProvincePlaceholder: 'Province',
  organizationPostalCode: 'Code postal*',
  organizationPostalCodePlaceholder: 'Code postal',
  phone: 'No de téléphone',
  phoneLabel: 'Numéro',
  phonePlaceholder: 'Numéro',
  phoneExtension: 'Numéro de poste',
  phoneExtensionPlaceholder: '123',
  timezone: 'Fuseau horaire*',
  timezones: {
    est: "Heure de l'Est",
    cst: 'Heure du Centre',
  },
  generalInfoTitle: 'Informations générales',
  organizationWebsite: "Site web de l'organisation",
  organizationWebsitePlaceholder: 'https://www.example.com',
  organizationProfileTitle: 'Profil de votre organisation',
  culturalOrganizationType:
    "Type d'organisation culturelle; sélectionnez toutes les options applicables*",
  role: "Fonction au sein de l'organisation*",
  rolePlaceholder: 'Rôle ou fonction',
  organizationRegionLabel:
    'Dans laquelle ou lesquelles des régions suivantes du Québec vous ou votre organisation êtes situé.e?*',
  organizationRegionSearch: 'Recherchez une région',
  organizationRegionTitle: 'Sélectionnez des options',
  disciplines:
    "Champs d'activité principal de l'organisation; sélectionner toutes les options applicables*",
  ticketingServiceLabel: 'Service de billeterie*',
  ticketingServiceSearch: 'Recherchez un service de billetterie',
  ticketingServiceTitle: 'Sélectionnez des options',

  submit: 'Soumettre',
  confirmAge:
    "J'atteste que je suis une personne de plus de 14 ans. Je confirme que je suis apte à communiquer ces informations à La Vitrine.",
  notificationsCheckboxesLabel: 'Notifications',
  consentsCheckboxesLabel: 'Consentements',
  confirmTerms: `J'ai pris connaissance et j'accepte les <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>Conditions générales d'utilisation</a> et la <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>Politique de confidentialité</a> de La Vitrine applicables à l'utilisation de l'Espace Pro.`,
  acceptNotifications: "J'accepte de recevoir des notifications de l'Espace Pro de La Vitrine",
  subscribeNewsletter: "Je souhaite m'abonner à l'infolettre Pro de La Vitrine",
  acceptTesting:
    'Je souhaite faire partie de la communauté de pratique en promotion numérique de La Vitrine.',
  errors: {
    organizationName: 'Veuillez entrer le nom de votre organisation',
    role: 'Veuillez entrer votre rôle ou fonction',
    address1: 'Veuillez entrer votre adresse',
    city: 'Veuillez entrer votre ville',
    province: 'Veuillez entrer votre province',
    postalCode: 'Veuillez entrer votre code postal',
    timezone: 'Veuillez sélectionner un fuseau horaire',
    culturalOrgTypes: "Veuillez sélectionner un type d'organisation culturelle",
    disciplines: 'Veuillez sélectionner une discipline',
    regions: 'Veuillez sélectionner une région',
    ticketingServices: 'Veuillez sélectionner un service de billetterie',
    confirmAge:
      'Veuillez confirmer que vous avez plus de 14 ans et accepter la politique de confidentialité de La Vitrine',
    confirmTerms: "Veuillez accepter les conditions d'utilisation de La Vitrine",
  },
})

Locale.getInstance().registerKeySet('en', 'partnerSignup', {
  organizationDescriptionTitle: 'Description of your organization',
  organizationName: 'What organization do you work for?*',
  organizationNamePlaceholder: 'Name of the organization',
  organizationAddressTitle: 'Complete organization address',
  organizationAddress1: 'Address 1*',
  organizationAddressPlaceholder: 'Number and street',
  organizationAddress2: 'Address 2',
  organizationAddress2Placeholder: 'Apartment, suite, etc.',
  organizationCity: 'City*',
  organizationCityPlaceholder: 'City',
  organizationProvince: 'Province*',
  organizationProvincePlaceholder: 'Province',
  organizationPostalCode: 'Postal code*',
  organizationPostalCodePlaceholder: 'Postal code',
  phone: 'Telephone number',
  phoneLabel: 'Number',
  phonePlaceholder: 'Number',
  phoneExtension: 'Extension',
  phoneExtensionPlaceholder: '123',
  timezone: 'Timezone*',
  timezones: {
    est: 'Eastern Time',
    cst: 'Central Time',
  },
  generalInfoTitle: 'General information',
  organizationWebsite: 'Organization website',
  organizationWebsitePlaceholder: 'https://www.example.com',
  organizationProfileTitle: 'Organization profile',
  culturalOrganizationType: 'Cultural organization type; select all applicable options*',
  role: 'Role within the organization*',
  rolePlaceholder: 'Enter your role or function',
  organizationRegionLabel:
    'In which of the following regions of Quebec are you or your organization located?*',
  organizationRegionSearch: 'Search for a region',
  organizationRegionTitle: 'Select options',
  disciplines: "Organization's main field of activity; select all applicable options*",
  ticketingServiceLabel: 'Ticket System*',
  ticketingServiceTitle: 'Select options',
  ticketingServiceSearch: 'Search for a ticket system',
  submit: 'Submit',
  confirmAge:
    'I hereby testify that I am over 14 years of age and qualified to communicate this information to La Vitrine.',
  notificationsCheckboxesLabel: 'Notifications',
  consentsCheckboxesLabel: 'Consents',
  confirmTerms: `I certify having read and hereby accept La Vitrine's <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>General Terms of Use</a> and <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>Privacy Policy </a> in relation to use of the Pro Zone`,
  acceptNotifications: "I agree to receive notifications from the La Vitrine's Pro Zone",
  subscribeNewsletter: 'I wish to subscribe to La Vitrine Pro Newsletter',
  acceptTesting: "I want to join La Vitrine's digital promotion community of practice",
  errors: {
    organizationName: 'Please enter your organization name',
    role: 'Please enter your role or function',
    address1: 'Please enter your address',
    city: 'Please enter your city',
    province: 'Please enter your province',
    postalCode: 'Please enter your postal code',
    timezone: 'Please select a timezone',
    culturalOrgTypes: 'Please select a cultural organization type',
    disciplines: 'Please select a discipline',
    regions: 'Please select a region',
    ticketingServices: 'Please select a ticketing service',
    confirmAge:
      'Please confirm that you are over 14 years old and accept La Vitrine privacy policy',
    confirmTerms: 'Please accept the terms and conditions of La Vitrine',
  },
})

const phoneMask = '###-###-####'
const ZIPCODE_MASK = 'A#A #A#'

export interface LvcPartnerSignupModalContent {}

export class LvcPartnerSignupModalContent extends MinzeElement {
  timezones: any = []
  culturalOrganizationTypes: any = []
  private onChangeCb: string = ''
  _authHandler: any = null
  showUserForm: boolean = true
  attrs: Attrs = [['loading', false]]
  reactive: Reactive = [
    ['loading', false],
    ['confirmTerms', false],
    ['confirmAge', false],
    ['confirmNewsletter', false],
    ['confirmNotifications', false],
    ['acceptTesting', false],
  ]

  handleAuthChanged = async (data: any): Promise<void> => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const auth = mainModule.getAuth()
    const lang = mainModule.getLang()
    const isPartner = await mainModule.getAuth().isPartner()
    const isPartnerInProcess = await mainModule.getAuth().isPartnerInProcess()

    if (data?.isLoggedIn && isPartner) {
      routing.goTo(Routing.ROUTES[lang].partnersPage)
    } else if (data?.isLoggedIn && !isPartner && isPartnerInProcess) {
      this.showUserForm = false
      this.rerender()
    }
  }

  async onReady(): Promise<void> {
    this.onChangeCb = Callback.attach(this.onChange.bind(this))
    const mainModule = MainModule.getInstance()
    this._authHandler = this.handleAuthChanged.bind(this)
    mainModule.getEE().on('lvc:user_state_changed', this._authHandler.bind(this))
    this.handleAuthChanged({
      isLoggedIn: await mainModule.getAuth().isLoggedIn(),
    })

    // Data is hardcoded in the config files
    this.timezones = config.timezones
    this.culturalOrganizationTypes = config.culturalOrganizationTypes

    this.rerender()
  }

  errors: any = {
    organizationName: false,
    role: false,
    address1: false,
    city: false,
    province: false,
    postalCode: false,
    timezone: false,
    culturalOrgTypes: false,
    disciplines: false,
    regions: false,
    ticketingServices: false,
    confirmTerms: false,
    confirmAge: false,
  }

  // function gets called when any input field changes
  onChange() {
    // Get values of all the inputs
    const inputIds = [
      'organization',
      'role',
      'adress1',
      'adress2',
      'city',
      'province',
      'postalCode',
      'phone',
      'phoneExtension',
      'website',
    ]
    const checkboxIds = [
      'confirmAge',
      'confirmTerms',
      'subscribeNewsletter',
      'acceptNotifications',
      'acceptTesting',
    ]
    const requiredCheckboxIds = ['confirmAge', 'confirmTerms']
    const values = inputIds.reduce(
      (acc, id) => {
        const element = this.select(`[name=\"${id}\"]`) as HTMLInputElement
        acc[id] = element?.value || ''
        return acc
      },
      {} as { [key: string]: string }
    )

    // Check if there are any non-empty values
    const hasValues = Object.values(values).some(value => value.trim() !== '')

    // Set the page to dirty or clearDirty accordingly
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    if (hasValues) {
      routing.setDirty()
    } else {
      routing.clearDirty()
    }

    for (const checkbox of checkboxIds) {
      const element = this.select(`[name=\"${checkbox}\"]`) as HTMLInputElement
      const checked = element?.getAttribute('checked') === 'true'
      this[checkbox] = checked
    }

    // if all inputs are filled, enable the submit button
    const allInputsFilled = Object.values(values).every(value => value.trim() !== '')
    const requiredCheckboxesChecked = requiredCheckboxIds
      .map(id => {
        const element = this.select(`[name=\"${id}\"]`) as HTMLInputElement
        const checked = element?.getAttribute('checked') === 'true'
        return checked
      })
      .every(checked => checked)

    this.submitButtonDisabled = !(allInputsFilled && requiredCheckboxesChecked)
  }

  getElementValue(selector: string): string {
    const element: HTMLInputElement | null = this.select(selector)
    return unescapeHtml(element?.value || '')
  }

  getJsonElementValue(selector: string): any[] {
    const element: HTMLInputElement | null = this.select(selector)
    return element?.value ? JSON.parse(decodeURIComponent(element.value)) : []
  }

  getElementChecked(name: string): boolean {
    const element: any = this.select(`[name="${name}"]`)
    const checkedVal = element?.getAttribute('checked')
    return checkedVal === 'true' || checkedVal === true
  }

  validateField(value: string, field: string, errorString: string) {
    if (!value) {
      this.errors[field] = errorString
    }
  }

  validateArrayField(value: any[], field: string, errorString: string) {
    if (value.length === 0) {
      this.errors[field] = errorString
    }
  }

  validateCheckbox(value: boolean, field: string, errorString: string) {
    if (!value) {
      this.errors[field] = errorString
    }
  }

  hasErrors(): boolean {
    return Object.values(this.errors).some(error => error)
  }

  resetErrors() {
    for (const key in this.errors) {
      this.errors[key] = false
    }
    this.rerender()
  }

  async onSignup(): Promise<void> {
    const mainModule = MainModule.getInstance()

    const organizationName = this.getElementValue('[name="organizationName"]')
    const role = this.getElementValue('[name="role"]')
    const address1 = this.getElementValue('[name="adress1"]')
    const address2 = this.getElementValue('[name="adress2"]')
    const city = this.getElementValue('[name="city"]')
    const province = this.getElementValue('[name="province"]')
    const postalCode = this.getElementValue('[name="postalCode"]')
    const phone = this.getElementValue('[name="phone"]')
    const phoneExtension = this.getElementValue('[name="phoneExtension"]')
    const regions = this.getJsonElementValue('[name="regions"]')
    const disciplines = this.getJsonElementValue('[name="disciplines"]')
    const timezones = this.getJsonElementValue('[name="timezones"]')
    const culturalOrgTypes = this.getJsonElementValue('[name="cultOrgTypes"]')
    const ticketingServices = this.getJsonElementValue('[name="ticketingServices"]')
    const website = this.getElementValue('[name="website"]')
    const bConfirmAge = this.getElementChecked('confirmAge')
    const bConfirmTerms = this.getElementChecked('confirmTerms')
    const bSubscribeNewsletter = this.getElementChecked('subscribeNewsletter')
    const bAcceptNotifications = this.getElementChecked('acceptNotifications')
    const bAcceptTesting = this.getElementChecked('acceptTesting')

    this.resetErrors()

    this.validateField(
      organizationName,
      'organizationName',
      Locale.getKey('partnerSignup.errors.organizationName')
    )
    this.validateField(role, 'role', Locale.getKey('partnerSignup.errors.role'))
    this.validateField(address1, 'address1', Locale.getKey('partnerSignup.errors.address1'))
    this.validateField(city, 'city', Locale.getKey('partnerSignup.errors.city'))
    this.validateField(province, 'province', Locale.getKey('partnerSignup.errors.province'))
    this.validateField(postalCode, 'postalCode', Locale.getKey('partnerSignup.errors.postalCode'))

    this.validateArrayField(timezones, 'timezone', Locale.getKey('partnerSignup.errors.timezone'))
    this.validateArrayField(
      culturalOrgTypes,
      'culturalOrgTypes',
      Locale.getKey('partnerSignup.errors.culturalOrgTypes')
    )
    this.validateArrayField(
      disciplines,
      'disciplines',
      Locale.getKey('partnerSignup.errors.disciplines')
    )
    this.validateArrayField(regions, 'regions', Locale.getKey('partnerSignup.errors.regions'))
    this.validateArrayField(
      ticketingServices,
      'ticketingServices',
      Locale.getKey('partnerSignup.errors.ticketingServices')
    )
    this.validateCheckbox(
      bConfirmAge,
      'confirmAge',
      Locale.getKey('partnerSignup.errors.confirmAge')
    )
    this.validateCheckbox(
      bConfirmTerms,
      'confirmTerms',
      Locale.getKey('partnerSignup.errors.confirmTerms')
    )

    if (postalCode.length < 7) {
      this.errors.postalCode = Locale.getKey('partnerSignup.errors.postalCode')
    }

    if (this.hasErrors()) {
      this.rerender()
      return
    }

    // get user data
    let user = await mainModule.getAuth().getUserData()
    if (!user) {
      return console.error('User not found')
    }

    let partnerData = {
      organizationName: organizationName,
      userId: user.profile.id,
      firstName: user.profile.personalData.firstName,
      lastName: user.profile.personalData.lastName,
      email: user.email,
      address1: address1,
      address2: address2,
      city: city,
      province: province,
      postalCode: postalCode,
      phoneExtension: phoneExtension,
      phone: phone,
      role: role,
      website: website,
      timezones: timezones,
      culturalOrgTypes: culturalOrgTypes,
      disciplines: disciplines,
      regions: regions,
      ticketingServices: ticketingServices,
      privacyPolicy: bConfirmAge,
      termsAndConditions: bConfirmTerms,
      proZoneNewsletter: bSubscribeNewsletter,
      acceptTesting: bAcceptTesting,
      proZoneNotifications: bAcceptNotifications,
    }

    const auth = mainModule.getAuth()
    this.loading = true
    let result = await auth.becomePartner(partnerData)

    if (result?.success) {
      this.loading = false
      this.showUserForm = false
      mainModule.getRouting().clearDirty()
      this.rerender()
    }
  }

  renderSignupCompleted() {
    return `<lvc-partner-signup-completed-modal-wrapper></lvc-partner-signup-completed-modal-wrapper>`
  }

  renderSignupForm() {
    return /*html*/ `<div class="container">
    <lvc-box class="form">
    <lvc-text font-preset="titleDesktopSmall" text-align="center" text-transform="uppercase">${Locale.getKey('partnerSignup.organizationDescriptionTitle')}</lvc-text>
      <lvc-box mt="8px" textAlign="${window.matchMedia(' (max-width: 730px)').matches ? 'left' : 'center'}"></lvc-box>
      <lvc-box mt="32px">
        <lvc-input on-change="${this.onChangeCb}" id="organizationName" placeholder="${Locale.getKey('partnerSignup.organizationNamePlaceholder')}" name="organizationName" error="${this.errors.organizationName}" label="${Locale.getKey('partnerSignup.organizationName')}"></lvc-input>
      </lvc-box>
      <lvc-box mt="12px" mb="12px">
        <lvc-input on-change="${this.onChangeCb}" id="role" name="role" placeholder="${Locale.getKey('partnerSignup.rolePlaceholder')}" error="${this.errors.role}" label="${Locale.getKey('partnerSignup.role')}"></lvc-input>
      </lvc-box>

      <lvc-box mt="32px">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerSignup.organizationAddressTitle')}</lv-text>
        <hr />
        <div class="address-container">
          <lvc-box>
            <lvc-input on-change="${this.onChangeCb}" id="adress1" error="${this.errors.address1}" placeholder="${Locale.getKey('partnerSignup.organizationAddressPlaceholder')}" name="adress1" error="${this.errors.adresse1}" label="${Locale.getKey('partnerSignup.organizationAddress1')}" required></lvc-input>
          </lvc-box>
          <lvc-box>
            <lvc-input on-change="${this.onChangeCb}" id="adress2" placeholder="${Locale.getKey('partnerSignup.organizationAddress2Placeholder')}" name="adress2" error="${this.errors.adresse2}" label="${Locale.getKey('partnerSignup.organizationAddress2')}"></lvc-input>
          </lvc-box>
          <lvc-box>
            <lvc-input on-change="${this.onChangeCb}" id="city" error="${this.errors.city}" placeholder="${Locale.getKey('partnerSignup.organizationCityPlaceholder')}" name="city" error="${this.errors.ville}" label="${Locale.getKey('partnerSignup.organizationCity')}" required></lvc-input>
          </lvc-box>
          <lvc-box>
            <lvc-input on-change="${this.onChangeCb}" id="province" error="${this.errors.province}" placeholder="${Locale.getKey('partnerSignup.organizationProvincePlaceholder')}" name="province" error="${this.errors.province}" label="${Locale.getKey('partnerSignup.organizationProvince')}" required></lvc-input>
          </lvc-box>
          <lvc-box>
            <lvc-input value="${escapeHtml((this.postalCode as string) || '')}" default-value="${escapeHtml((this.postalCode as string) || '')}" on-change="${this.onChangeCb}" id="postalCode" mask="${ZIPCODE_MASK}" error="${this.errors.postalCode}" placeholder="${Locale.getKey('partnerSignup.organizationPostalCodePlaceholder')}" name="postalCode" error="${this.errors.codePostal}" label="${Locale.getKey('partnerSignup.organizationPostalCode')}" required></lvc-input>
          </lvc-box>
        </div>
      </lvc-box>

      <lvc-box mt="32px" mb="32px">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerSignup.phone')}</lvc-text>
        <hr />
        <div class="phone-container">
          <lvc-input value="${escapeHtml((this.phone as string) || '')}" default-value="${escapeHtml((this.phone as string) || '')}" on-change="${this.onChangeCb}" id="phone" placeholder="${Locale.getKey('partnerSignup.phonePlaceholder')}" name="phone" error="${this.errors.phone}" label="${Locale.getKey('partnerSignup.phoneLabel')}" mask=${phoneMask}></lvc-input>
          <lvc-input value="${escapeHtml((this.phoneExtension as string) || '')}" default-value="${escapeHtml((this.phoneExtension as string) || '')}" on-change="${this.onChangeCb}" id="phoneExtension" placeholder="${Locale.getKey('partnerSignup.phoneExtensionPlaceholder')}" name="phoneExtension" error="${this.errors.phoneExtension}"mask="#####" label="${Locale.getKey('partnerSignup.phoneExtension')}"></lvc-input>
        </div>
      </lvc-box>
      
      <lvc-box mt="32px" name="general-info-container">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerSignup.generalInfoTitle')}</lv-text>
        <hr />
        <lvc-box>
            <lvc-pro-space-select
              id="timezones"
              name="timezones"
              title="${Locale.getKey('partnerSignup.timezone')}"
              items="${encodeURIComponent(JSON.stringify(this.timezones))}"
              background="white"
              error="${this.errors.timezone}"
              can-select-multiple=${false}
              >
            </lvc-pro-space-select>
            <lvc-error error="${this.errors.timezone}"></lvc-error>
        </lvc-box>
        <lvc-box mt="12px">
          <lvc-input on-change="${this.onChangeCb}" id="website" placeholder="${Locale.getKey('partnerSignup.organizationWebsitePlaceholder')}" name="website" error="${this.errors.website}" label="${Locale.getKey('partnerSignup.organizationWebsite')}"></lvc-input>
        </lvc-box>      
      </lvc-box>

      <lvc-box mt="32px" name="organization-profile-container">
        <lvc-text font-preset="medium" font-weight="bold">${Locale.getKey('partnerSignup.organizationProfileTitle')}</lvc-text>
        <hr />

        <lvc-box>
            <lvc-pro-space-select
              id="cultOrgTypes"
              name="cultOrgTypes"
              title="${Locale.getKey('partnerSignup.culturalOrganizationType')}"
              items="${encodeURIComponent(JSON.stringify(this.culturalOrganizationTypes))}"
              background="white"
              error="${this.errors.culturalOrgTypes}"
              can-select-multiple=${true}
              >
            </lvc-pro-space-select>
        </lvc-box>
        <lvc-box mt="12px">
          <lvc-multiple-disciplines-field
            id="disciplines"
            name="disciplines"
            title="${Locale.getKey('partnerSignup.disciplines')}"
            items="${encodeURIComponent(JSON.stringify(this.disciplines))}"
            background="white"
            error="${this.errors.disciplines}"
            >
        </lvc-multiple-disciplines-field>

        <lvc-box mt="12px">
          <lvc-regions-field id="regions" name="regions" type="organizationRegion" chooseLabel="${Locale.getKey('partnerSignup.organizationRegionTitle')}" 
          title="${Locale.getKey('partnerSignup.organizationRegionLabel')}" placeholder="${Locale.getKey('partnerSignup.organizationRegionSearch')}" 
          label="${Locale.getKey('partnerSignup.organizationRegion')}" background="white" error="${this.errors.regions}"></lvc-regions-field>
        </lvc-box>
        <lvc-box mt="12px">
          <lvc-ticketing-services-field id="ticketingServices" name="ticketingServices" type="ticketingServices" chooseLabel="${Locale.getKey('partnerSignup.ticketingServiceTitle')}" 
          title="${Locale.getKey('partnerSignup.ticketingServiceLabel')}" placeholder="${Locale.getKey('partnerSignup.ticketingServiceSearch')}" 
          label="${Locale.getKey('partnerSignup.ticketingServiceLabel')}" background="white" error="${this.errors.ticketingServices}"></lvc-ticketing-services-field>
        </lvc-box>
      </lvc-box>



      <lvc-box mt="12px">
        <label>${Locale.getKey('partnerSignup.notificationsCheckboxesLabel')}</label>
      </lvc-box>

      <lvc-box mt="12px">
        <lvc-checkbox on-change="${this.onChangeCb}" default-value="${this.subscribeNewsletter}" checked="${this.subscribeNewsletter}" label="${Locale.getKey('partnerSignup.subscribeNewsletter')}" name="subscribeNewsletter" 
        ></lvc-checkbox>
      </lvc-box>

      <lvc-box mt="12px">
      <lvc-checkbox on-change="${this.onChangeCb}" default-value="${this.acceptTesting}" checked="${this.acceptTesting}" label="${Locale.getKey('partnerSignup.acceptTesting')}" name="acceptTesting"
      ></lvc-checkbox>
      </lvc-box>

       <lvc-box mt="12px">
        <lvc-checkbox on-change="${this.onChangeCb}" default-value="${this.acceptNotifications}" label="${Locale.getKey('partnerSignup.acceptNotifications')}" name="acceptNotifications" checked="${this.acceptNotifications}"
        ></lvc-checkbox>
      </lvc-box>

      <lvc-box mt="12px">
        <label>${Locale.getKey('partnerSignup.consentsCheckboxesLabel')}</label>
      </lvc-box>
      
      <lvc-box mt="12px">
         <lvc-checkbox on-change="${this.onChangeCb}" name="confirmTerms" default-value="${this.confirmTerms}" checked="${this.confirmTerms}" label="${Locale.getKey('partnerSignup.confirmTerms')}" 
         error="${this.errors.confirmTerms}"/>
      </lvc-box>

      <lvc-box mt="12px">
      <lvc-checkbox on-change="${this.onChangeCb}" name="confirmAge" default-value="${this.confirmAge}" checked="${this.confirmAge}" label="${Locale.getKey('partnerSignup.confirmAge')}" 
      error="${this.errors.confirmAge}"/>
    </lvc-box>

      <lvc-box mt="12px">
        <lvc-error error="${this.errors.general}"></lvc-error>
      </lvc-box>
      <lvc-box mt="12px" display="${window.matchMedia(' (max-width: 730px)').matches ? 'block' : 'flex'}" width="100%" height="100%" justifyContent="center">
        <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia('(max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button" type="submit" 
          disabled="${this.loading}" background="${this.loading ? '#6a54b1' : '#1E007D'}" height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px" name="submit"> ${Locale.getKey('partnerSignup.submit')} 
        </lvc-button>
      </lvc-box>
    </lvc-box>
  </div>
    ${
      window.matchMedia('(max-width: 730px)').matches
        ? ''
        : `
      <lvc-charlie-hands-together></lvc-charlie-hands-together>
    `
    }

  `
  }

  html = () => {
    return this.showUserForm ? this.renderSignupForm() : this.renderSignupCompleted()
  }

  css = () => `
    :host {
     
    }

    hr {
      border: 0;
      border-radius: 999px;
      height: 2px;
      background: rgba(30, 0, 125, 0.2); /* Adjust the alpha value as needed */
      margin: 12px 0; /* Adjust the spacing as needed */
    }

    .phone-container {
      margin-top: 12px;
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 16px;
      align-items: end;
    }

    .address-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px; /* Adjust the gap as needed */
    }

    .address-container div {
      display: flex;
      flex-direction: column;
    }
    
    a, a:visited {
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      text-decoration: none;
      color: #1E007D;
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 24px;
    }

    .form {
      flex-grow: 4;
    }

    lvc-charlie-hands-together {
      position: fixed;
      right: -37px;
      bottom: -108px;
      height: 432px;
      pointer-events: none;
      z-index: -1;
    }

    label {
      font-family: inherit;
      color: #1E007D;
      font-size: 14px;
      line-height: 17px;
      font-weight: ${Font.weight.bold};
      margin-bottom: 4px;
    }


    a>u:hover {
      color: #FFF;
    }
    
    
    @media (max-width: 730px) {
      .phone-container {
        display: flex;
        flex-direction: column;
      }
  `

  eventListeners: EventListeners = [['.button', 'click', this.onSignup.bind(this)]]
}
